export default "__VITE_ASSET__B5Legd1z__"